import { createContext } from 'react'

import type { ModuleAvailabilityType } from 'modules/core/hooks/useModuleAvailability'

export interface WorkflowSurveysContextProps {
  moduleAvailabilities: ModuleAvailabilityType[]
  upsellFlowEnabled: boolean
  loading: boolean
  canCreateForms: boolean
  canCreateTemplates: boolean
  canManageSurveys: boolean
  canCreateEverybody: boolean
  canCreateReportees: boolean
}

export const WorkflowSurveysContext = createContext<WorkflowSurveysContextProps | null>(null)
